// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TAILSCALE SPLIT DNS SCHEMA
/////////////////////////////////////////

export const TailscaleSplitDnsSchema = z.object({
  nameservers: z.string().array(),
  domains: z.string().array(),
})

export type TailscaleSplitDns = z.infer<typeof TailscaleSplitDnsSchema>

export default TailscaleSplitDnsSchema;
